import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { truncateFirstName } from "../../helpers/stringFormatters";
import "./Header.sass";
import { useStep } from "../../context/StepContext"
import { LanguageSelector } from "../LanguageSelector/LanguageSelector";
import { isEvent } from "../../basedata/constants";

interface HeaderProps {
  variant?: 'default' | 'dark' | 'primary';
}

const MAX_NAME_LENGTH = 20;

const Header = ({ variant = 'default' }: HeaderProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isHome = location.pathname === "/";

  const { step } = useStep();

  const fullName = localStorage.getItem("name");
  const firstName = truncateFirstName(fullName, MAX_NAME_LENGTH);

  return (
    <Box className={`header-wrapper header-${variant}${isEvent() ? ' header-event' : ''}`}>
      {step > -1 && (
        <Box className="progress-indicator">
          {Array.from({ length: 6 }).map((_, index) => (
            <Box
              key={index}
              className={`progress-bar ${index < step ? "set-step" : "set-gray"}`}
            />
          ))}
        </Box>
      )}
      <Box className="header-bottom">
        {firstName && !isHome && (
          <Box className="header-name-container">
            <Typography className="header-user-name">
              {t("signup.messages.register_hello")}, {firstName}
            </Typography>
          </Box>
          )}
          v.6.8
        <LanguageSelector />
      </Box>
    </Box>
  );
};

export default Header;
